import {
  LISTING_ATTRIBUTE_SECTIONS,
  mergeListingAttributes
} from '../config/listingAttributesModel';

const NEGATIVE_YESNO_KEYS = new Set([
  'smokingAllowed',
  'alcoholAllowed',
  'visitorsAllowed'
]);

function shortenLabel(label) {
  const cut = label.split('(')[0].split('—')[0];
  return cut.trim();
}

/**
 * Single human-readable line for a field value (for chips / lists).
 */
function fieldToLine(field, val) {
  if (val == null || val === '') return null;

  if (field.type === 'yesno') {
    if (val === 'Yes') return shortenLabel(field.label);
    if (val === 'No' && NEGATIVE_YESNO_KEYS.has(field.key)) {
      if (field.key === 'smokingAllowed') return 'No smoking';
      if (field.key === 'alcoholAllowed') return 'No alcohol';
      if (field.key === 'visitorsAllowed') return 'No visitors';
    }
    return null;
  }

  if (field.type === 'multiselect') {
    if (!Array.isArray(val) || val.length === 0) return null;
    const head = shortenLabel(field.label);
    return `${head}: ${val.join(', ')}`;
  }

  if (field.type === 'number') {
    const n = typeof val === 'number' ? val : Number(val);
    if (Number.isNaN(n)) return null;
    if (field.key === 'bedroomsCount') {
      return `${n} bedroom${n === 1 ? '' : 's'}`;
    }
    if (field.key === 'bathroomsCount') {
      return `${n} bathroom${n === 1 ? '' : 's'}`;
    }
    if (field.key === 'distanceFromCityKm') {
      return `${shortenLabel(field.label)}: ${n} km`;
    }
    return `${shortenLabel(field.label)}: ${n}`;
  }

  if (field.type === 'select') {
    return `${shortenLabel(field.label)}: ${val}`;
  }

  return null;
}

/**
 * Combined amenity lines for search cards and property page: structured
 * `listingAttributes` plus free-text `stay.amenities`, de-duplicated by
 * lowercase text, order preserved.
 */
export function getStayAmenityDisplayLines(stay) {
  const la = mergeListingAttributes(stay?.listingAttributes);
  const lines = [];
  const seen = new Set();

  const add = (s) => {
    if (!s || typeof s !== 'string') return;
    const t = s.trim();
    if (!t) return;
    const k = t.toLowerCase();
    if (seen.has(k)) return;
    seen.add(k);
    lines.push(t);
  };

  const skip = new Set();

  if (la.wifi === 'Yes') {
    add('Wi‑Fi');
    skip.add('wifi');
  }

  for (const section of LISTING_ATTRIBUTE_SECTIONS) {
    for (const field of section.fields) {
      if (skip.has(field.key)) continue;
      const line = fieldToLine(field, la[field.key]);
      if (line) add(line);
    }
  }

  const extra = Array.isArray(stay?.amenities) ? stay.amenities : [];
  for (const a of extra) {
    if (typeof a === 'string' && a.trim()) add(a.trim());
  }

  return lines;
}
